import { ReactElement } from 'react'
import { Link } from '@zoom/react-ui'
import { IconPopWindowPopOutSmallV2 } from '@zoom/icons-react'

type FileNameTitle = {
  fileName: string
  onLinkClick: () => void
  icon: ReactElement
}
const FileNameTitle: React.FC<FileNameTitle> = ({
  icon,
  fileName,
  onLinkClick,
}) => {
  return (
    <div className='group flex h-[30px] w-full items-center justify-between overflow-hidden'>
      <div className='mr-2'>{icon}</div>
      <span className='mr-1.5 font-sans !text-customGray'>Share</span>
      <div className='mt-2 w-[calc(100%-24px)] truncate'>
        <Link
          className='w-full !text-customGray'
          component='button'
          onClick={onLinkClick}
          underline='hover'
        >
          <span className='h-[30px] max-w-[280px] truncate font-sans group-hover:underline'>
            {fileName}
          </span>
        </Link>
      </div>
      <div
        className={`invisible flex items-center p-[2px] group-hover:visible`}
      >
        <IconPopWindowPopOutSmallV2 style={{ fontSize: '14px' }} />
      </div>
    </div>
  )
}

export default FileNameTitle
